import React, { Fragment } from 'react';
import { st, pt, lt } from './texte'
import { constants, validateEmail } from './common';
import { InputFeld, SelectFeld, DatumFeld } from './Felder'
import { onlineCheckin } from './Interface.js'

const hasInvalidEmailDowngrade = (checkindata) => {
  for (const id_bett in checkindata) {
    const pers = checkindata[id_bett];
    for (let i = 0; i < pers.length; i++) {
      const feld = pers[i];
      if (feld.feld === constants.PersFEmail) {
        const oldValue = (feld.origvalue || '').trim();
        const newValue = (feld.value || '').trim();
        if (validateEmail(oldValue) && newValue.length > 0 && !validateEmail(newValue)) {
          return true;
        }
      }
    }
  }
  return false;
};

const getCheckinValue = (value) => {
  return value === null || typeof value === 'undefined'?'':String(value);
};

const hasCheckinChanges = (checkindata) => {
  for (const id_bett in checkindata) {
    const pers = checkindata[id_bett];
    for (let i = 0; i < pers.length; i++) {
      if (getCheckinValue(pers[i].value) !== getCheckinValue(pers[i].origvalue)) {
        return true;
      }
    }
  }
  return false;
};

const OnlineCheckin = (props) => { 
  const { appState, setState } = props;
  var checkindata = appState.bookingData.checkin;
  const checkinSaved = appState.checkin > 1 && !appState.checkinDirty && !appState.checkinSaving;
  const canStore = appState.checkinDirty && !appState.checkinSaving;

  const fieldChange = (n) => event => {
    var v = event.target.value;
    const s = n.split('|');
    setState(st=>{
      var old = st.bookingData.checkin[s[1]][s[0]].value; 
      if (s[2]==='Y') {
        v = (old % 10000) + parseInt(v) * 10000;
      }
      if (s[2]==='M') {
        v = (old - Math.floor(old/100)%100 * 100) + parseInt(v) * 100;
      }
      if (s[2]==='D') {
        v = (old - old % 100) + parseInt(v) ;
      }
      st.bookingData.checkin[s[1]][s[0]].value = v ; 
      st.checkinDirty = hasCheckinChanges(st.bookingData.checkin);
      return st
    });
  }
  
  const store = () => {
    if (!canStore) {
      return;
    }
    if (hasInvalidEmailDowngrade(checkindata)) {
      setState({
        error: st['bwh.loginerror.email.invalid'] || 'Invalid email address',
      });
      return;
    }
    setState({checkinSaving:true});
    onlineCheckin(appState, setState, checkindata);
  }

  const laenderlist = [];
  for (var i=0;i<lt.list.length;i++) {
    laenderlist.push({value:lt.list[i]['land_id'], text:lt.list[i]['land']});
  }
  
  const personen = [];
  const checkinorder = appState.bookingData.checkinorder || Object.keys(checkindata);
  for(i=0; i<checkinorder.length; i++) {
    var id_bett = checkinorder[i];
    var pers = checkindata[id_bett];
    var felder = [];
    for (var j=0; j<pers.length; j++) {
      var cd = pers[j];
      if (i===0 || cd.typ===2 || cd.typ===4) {
        var optionlist = false;
        if (pt.hostel_guestfield_options && pt.hostel_guestfield_options[cd.feld] && pt.hostel_guestfield_options[cd.feld]!== "") {
          var options = pt.hostel_guestfield_options[cd.feld].split("\n");
          optionlist = [];
          for (var k=0;k<options.length;k++) {
            var s = options[k].split('=');
            optionlist.push({value:s[0], text:s[1]?s[1]:s[0]});
          }
        }
        if (cd.feld===constants.PersFLand || cd.feld===constants.PersFPassLand) {
          felder.push(
            <SelectFeld 
              key={cd.feld} 
              name={j+'|'+id_bett} 
              titel={ pt.hostel_guestfield[cd.feld]} 
              value={cd.value} 
              required={cd.typ > 2}
              change={fieldChange}
              disabled={appState.checkinSaving}
              list={laenderlist}
            />);
          
        }
        else if (cd.feld===constants.PersGebDat) {
          felder.push(
            <DatumFeld 
              key={cd.feld} 
              name={j+'|'+id_bett} 
              titel={ pt.hostel_guestfield[cd.feld]} 
              value={cd.value} 
              required={cd.typ > 2}
              change={fieldChange}
              disabled={appState.checkinSaving}
            />);
        }
        else if (optionlist) {
          felder.push(
            <SelectFeld 
              key={cd.feld} 
              name={j+'|'+id_bett} 
              titel={ pt.hostel_guestfield[cd.feld]} 
              value={cd.value} 
              required={cd.typ > 2}
              change={fieldChange}
              disabled={appState.checkinSaving}
              list={optionlist}
            />);
          
        }
        else {
          let valid = 0;
          if (cd.feld===constants.PersFEmail) {
            const oldValue = (cd.origvalue || '').trim();
            const newValue = (cd.value || '').trim();
            if (validateEmail(oldValue)) {
              if (newValue.length === 0) {
                valid = 0;
              }
              else {
                valid = validateEmail(newValue) ? 1 : -1;
              }
            }
          }
          felder.push(
            <InputFeld 
              key={cd.feld} 
              name={j+'|'+id_bett} 
              titel={ pt.hostel_guestfield[cd.feld]} 
              value={cd.value} 
              required={cd.typ > 2}
              valid={valid}
              change={fieldChange}
              disabled={appState.checkinSaving}
            />);
          
        }
      }
    }
    
    if (felder.length) {
      personen.push(
        <div id="gewaehltesangebot_wrap" className="filterbereich-wrap clearfix" style={{backgroundColor: 'rgba(242, 242, 242, 0.8)'}} key={i}>
          <div className="filterbereich clearfix">
            <div className="filterbereich-titel">
              <p className="filterbereich-titeltext">{i===0?'Main guest':(i+1)+'. Person'}</p>
            </div>
            <div className="clearfix bereichinhalt-wrap">
              {felder}
            </div>
          </div>
        </div>
      );
    }
  }
  return (
    <Fragment>
      <div id="buchungfertig" className="clearfix">
        <div className="clearfix">
          <h1>{st['bwh.checkintitel']}</h1>
        {checkinSaved && <h2>{st['bwh.checkinsaved']}</h2>}
        </div>
      </div>
      {personen}
      <div className="confirm-aktion-button-wrap" style={{float: 'none', margin: '1em auto 8em auto'}}>
        <div id="bu_storechecken" className={'confirm-aktion-button'+(!canStore?' disabled':'')} onClick={canStore?store:null} aria-disabled={!canStore}>
          <p className="confirm-aktion-button-text" style={{float: 'none'}}>{appState.checkinSaving?(st['bwh.checkinsaving'] || 'Wird gespeichert ...'):st['bwh.checkinbutton.store']}</p>
        </div>
      </div>
    </Fragment>
  )
}
export default OnlineCheckin;
